export default {
  40: {
    classDiary: false
  }
};
